import { FileDTO } from "../requests/files/types";
import { fileToBase64String } from "./dataParsing";
import { EmailAttachment } from "../requests/feedback/types";

export const fileToDto = async (file: File, fileId: string): Promise<FileDTO> =>
  fileToBase64String(file).then((base64Content) => ({
    fileId,
    fileName: file.name,
    contentType: file.type,
    content: base64Content,
  }));

export const fileToAttachment = async (file: File): Promise<EmailAttachment> =>
  fileToBase64String(file).then((base64Content) => ({
    fileName: file.name,
    mimeType: file.type,
    base64File: base64Content,
  }));

export function renameFile(originalFile: File, newName: string) {
  return new File([originalFile], newName, {
    type: originalFile.type,
    lastModified: originalFile.lastModified,
  });
}

export const blobToBase64 = (blob: Blob) => {
  const reader = new FileReader();
  reader.readAsDataURL(blob);
  return new Promise((resolve, _) => {
    reader.onload = () => {
      const dataUrl = reader.result;

      if (!dataUrl || typeof dataUrl !== "string") {
        resolve(null);
        return;
      }

      const base64 = dataUrl.split(",")[1];
      resolve(base64);
    };
  });
};
